import { AppShellProvider } from '../appShell';
import {
  SdfMfeLoader
} from '@waypoint/react-components';
const webhookUIBaseUrl = import.meta.env.VITE_API_BASE_URL;
const appShellBaseUrl = import.meta.env.VITE_APP_SHELL_BASE_URL;

function SubscriptionWebhook({ mfeKey, carId, locale }) {
  return (
    <>
      <div className="px-8">
        {/* Loading the appShell */}
        <AppShellProvider baseURL={appShellBaseUrl} locale={locale}>
          {/* Loading the OpenADP WebhookUI MFE */}
          <SdfMfeLoader
            key={mfeKey}
            id='subscription-webhook-mfe'
            // baseUrl={'http://localhost:37093'} // For local MFE testing
            baseUrl={`${webhookUIBaseUrl}/marketplace-subscription-webhookui-mfe`}
            scriptName="config/marketplace-subscription-webhookui-config.js"
            globalObject="subscriptionManagerConfig"
            componentTagName="mp-subscription-webhook-ui"
            dataAttrCid={carId}
          />
        </AppShellProvider>
      </div>

      {/* Spacing */}
      <br />
      <br />
      <br />
      <br />
    </>
  );
}

export default SubscriptionWebhook;
